<template>
<div>
  <div class="container containerwrap" v-bind:class="{opacity03:isSendok}">
    <div id="bgImgWrap">
      <img :src="bgimg" id="bgImg">
    </div>
    <div class="custInfoContainer">
      <div class="group c_flex ">
          <div class="c_flex_between c_flex fieldname">
            <div class="c_flex c_item_center"><span class="isneed c_red">*</span></div>
            <div class="c_flex c_item_center"><span>姓名：</span></div>
          </div>
          <div class="content c_flex_1 c_item_center c_flex c_m_l_10">
            <input type="text" class="widthauto" v-model="custInfo.username" placeholder="请输入您的称呼">
          </div>
        </div>
        <div class="group c_flex c_item_center">
          <div class="border c_flex_1 c_flex">
            <div class="c_flex_between c_flex fieldname">
               <div class="c_flex c_item_center"><span class="isneed c_red">*</span></div>
               <div class="c_flex c_item_center"><span>手机：</span></div>
            </div>
            <div class="content c_flex_1 c_flex c_item_center c_m_l_10">
              <input class="c_flex_1" type="tel" v-model="custInfo.phone" placeholder="请输入您的手机号码">
            </div>
          </div>
        </div>
        <div class="group c_flex c_item_center">
          <div class="border c_flex_1 c_flex">
            <div class="c_flex_between c_flex fieldname">
               <div class="c_flex c_item_center"><span class="isneed c_red">*</span></div>
               <div class="c_flex c_item_center"><span>区域：</span></div>
            </div>
            <div class="content c_flex_1 c_flex c_item_center c_m_l_10" @click="addrClick">
              <span class="item-value c_no_pointer c_nowrap">
                <input class="c_flex_1 inputpart" type="text" v-model="addresshelp" placeholder="请选择您的城市和区域" disabled="disabled">
                <!-- {{(custInfo.province == custInfo.city ? custInfo.province + custInfo.district : custInfo.province + custInfo.city + custInfo.district)||'请选择所在区域'}} -->
                <input
                  type="hidden"
                  placeholder="请选择省"
                  v-model="custInfo.province"
                />
                <input type="hidden" placeholder="请选择市" v-model="custInfo.city" />
                <input type="hidden" placeholder="请选择区" v-model="custInfo.district" />
              </span>
            </div>
            <div class="selectImgWrap c_flex c_item_center">
              <img :src="selectImg" class="selectImg">
            </div>
          </div>
        </div>
        <div class="group c_flex c_item_center">
          <div class="border c_flex_1 c_flex">
            <div class="c_flex_between c_flex fieldname">
               <div class="c_flex c_item_center"></div>
               <div class="c_flex c_item_center"><span>地址：</span></div>
            </div>
            <div class="content c_flex_1 c_flex c_item_center c_m_l_10">
              <input class="c_flex_1" type="text" v-model="custInfo.address" placeholder="请输入您的详细地址">
            </div>
          </div>
        </div>
        <div class="group c_flex c_item_center">
          <div class="border c_flex_1 c_flex">
            <div class="c_flex_between c_flex fieldname">
               <div class="c_flex c_item_center"> <span class="isneed c_red">*</span></div>
               <div class="c_flex c_item_center"><span>部位：</span></div>
            </div>
            <div class="content c_flex_1 c_flex c_item_center c_m_l_10" @click="partClick">
              <input class="c_flex_1 inputpart" type="text" v-model="custInfo.part" placeholder="请选择您需要维修的部位" disabled="disabled">
            </div>
            <div class="selectImgWrap c_flex c_item_center" @click="partClick">
              <img :src="selectImg" class="selectImg">
            </div>
          </div>
        </div>
    </div>
    <div id="footerWrap">
      <div class="toSaveInfoBtn" @click="toSaveCustInfo">预约上门勘察</div>
      <div class="c_center" style="margin-top:4vw">
        <p class="f_size_35 c_flex c_flex_center">
          <van-checkbox v-model="isread" class="c_m_r_10"></van-checkbox>
          <!-- <span class="c_m_r_10"><input type="checkbox" v-model="isread"></span> -->
          <span class="agreement" @click="readAgreement">我已阅读并且同意《保密协议》</span></p>
      </div>
    </div>
    <!--所在区域弹窗-->
    <div class="model_addr" v-show="addr.isShow">
      <div class="model-bg" @click="saveAddrClick"></div>
      <div class="model-body">
        <div class="model-header c_flex c_flex_between c_item_center">
          <div class="model-title">城市地区选择</div>
          <div class="model-cancel" @click="saveAddrClick(true)">×</div>
        </div>
        <div class="model-hot">
          <div class="model-hot-title">热门省市</div>
          <div class="model-hot-list c_flex">
            <div
              class="model-hot-group"
              v-for="(item,index) in addr.hotList"
              :key="index"
              :class="((addr.province==item.province)&&(addr.city==item.city))?'bg_red':''"
            >
              <div class="model-item c_flex c_flex_center" @click="hotClick(item)">{{item.name}}</div>
            </div>
          </div>
        </div>
        <div class="model-choose">
          <div class="model-hot-title">省市区选择</div>
          <div class="model-choose-title c_flex">
            <div
              :class="addr.province?'':'c_red'"
              @click="chooseAddress('province')"
            >{{addr.province||'请选择'}}</div>
            <div
              v-show="addr.province"
              :class="addr.city?'':'c_red'"
              @click="chooseAddress('city')"
            >{{addr.city||'请选择'}}</div>
            <div
              v-show="addr.province && addr.city"
              :class="addr.district?'':'c_red'"
              @click="chooseAddress('district')"
            >{{addr.district||'请选择'}}</div>
          </div>
          <div class="model-choose-list">
            <div
              class="model-choose-group"
              :class="index % 2 ==0 ? 'bg-fcfcfc':'bg_white' "
              v-for="(item,index) in addr.chooseList"
              :key="index"
            >
              <div
                class="model-item"
                :class="addr.chooseType=='province'?(item.name==addr.province?'c_red':''):(addr.chooseType=='city'?(item.name==addr.city?'c_red':''):(addr.district==item.name?'c_red':''))"
                @click="chooseClick(item)"
              >{{item.name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--选择渗漏部位-->
    <div class="model_addr" v-show="partParam.isShow">
      <div class="model-bg" @click="savePartClick"></div>
      <div class="model-body">
        <div class="model-header c_flex c_flex_between c_item_center">
          <div class="model-title">渗漏部位选择</div>
          <div class="model-cancel" @click="savePartClick(true)">×</div>
        </div>
        <div class="model-choose">
          <div class="model-hot-title">渗漏部位</div>
          <div class="model-choose-title c_flex">
            <div :class="partParam.partone?'':'c_red'" @click="choosePart('partone')">{{partParam.partone||'请选择'}}</div>
            <div v-show="partParam.parttwo" :class="partParam.two?'':'c_red'" @click="choosePart('parttwo')">{{partParam.parttwo||'请选择'}}</div>
          </div>
          <div class="model-choose-list">
            <div class="model-choose-group" :class="index % 2 ==0 ? 'bg-fcfcfc':'bg_white' " v-for="(item,index) in partParam.chooseList" :key="index">
              <div class="model-item" :class="partParam.chooseType=='partone'?(item.codetext==partParam.partone?'c_red':''):(partParam.chooseType=='parttwo'?(item.codetext==partParam.parttwo?'c_red':''):'')" @click="partChooseClick(item)">
                {{item.codetext}}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
  <!-- 留资通过弹窗 -->
  <div class="custinfoOKWrap" v-show="isSendok">
      <div style="position: relative;">
        <img :src="custInfoOkImg" class="custInfoOkImg">
        <img :src="closeImg" class="closeInfoOk" @click="closeInfoOk()">
        <!-- <span >X</span> -->
      </div>
      <p class="text1">恭喜您预约成功</p>
      <p class="text2">我们将尽快和您取得联系,请您保持 <br />手机畅通,注意接听陌生电话</p>
  </div>
  <!-- 保密协议弹窗 -->
  <div class="isLookSecretWrap"  v-show="isLookSecret">
    <div class="secretContentWrap">
      <div class="secretHead">
          <h1 class="c_center ">个人信息授权与保护声明
            
          </h1>
          
      </div>
    
    <div class="secretContent">
    <p>
      我们非常重视用户信息的保护。您在使用我们的服务时，我们可能会收集和使用您的相关信息。我们希望通过本声明向您说明在适用于具体的留资场景时我们如何收集、使用、共享、保护您的信息，以进一步保障您的信息安全和为您提供更具个性化的优质服务。在使用我们的留资服务（以下简称“服务”），并在相应页面填写相关信息前，请您务必仔细阅读本声明。您一旦主动在相应页面填写信息并进行提交操作，即意味着您同意我们按照本声明收集、使用、共享您的相关信息。
    </p>
    <div>
      <h2>一、个人信息的收集</h2>  
      <p>
        1、我们提供服务时，可能会收集您的姓名、手机号。请您注意，具体需要填写的信息可能会根据我们提供的产品/服务的不同而有所差异，请以届时向您展示的服务以及所对应的要求填写相关个人信息，但我们会在下文向您说明我们可能收集的全部个人信息的收集和使用规则。
      </p>
      <p>
        2、您需要注意的是，以上个人信息均是您自愿提供。您有权拒绝提供，但可能无法正常使用相应的服务、功能或者无法达到服务拟达到的效果。
      </p>
      <p>
        3、对于不满 18 岁的用户，须在其监护人陪同未成年人用户已经阅读和理解本声明并且许可的情况下向我们提交相关个人信息。
      </p>
    </div>
    <div>
      <h2>二、个人信息的使用和共享</h2>  
      <p>
        1、您同意，我们可以通过以下方式对个人信息进行使用和共享：
        <span class="in-block">
          ①	为了保障您能正常使用由我们的关联方或合作方提供的相关功能或服务，或为保障使用安全或进行必要的产品使用分析，我们可能会与上述各方共享所必需的信息；
        </span>
        <span class="in-block">
          ②	我们和合作商为满足您的需求，可能通过您提供的信息与您联系；
        </span>
        <span class="in-block">
          ③	我们和合作商可能定期或不定期向您发送有关产品、服务或相关活动的信息；
        </span>
        <span class="in-block">
          ④	 如您拟修改您提交的个人信息的，您可以及时通过<a :href="'tel:400-770-8966'">400-770-8966</a>与我们联系，我们将尽快配合处理。
        </span>
      </p>
      <p>
        2、我们将严格保护您的个人信息安全。我们将采用适当制度、安全技术和程序等措施来保护您的个人信息不被未经授权的访问、使用或泄漏。我们亦将促使本声明所述各接收和使用方尽力保护和不予泄露您的个人信息。
      </p>
      <p>
        3、我们将要求并敦促个人信息接收方遵循本声明和法律法规的规定，谨慎使用其接收到的个人信息，如其发生超越本声明范围使用您的个人信息，进而侵害您合法权益的情形，我们将协助您追究该接收方的法律责任。
      </p>
    </div>
    <div>
      <h2>三、适用法律</h2>  
      <p>
        1、本声明适用中华人民共和国法律。
      </p>
      <p>
        2、如果您对信息保护问题有任何疑问或选择取消授权的，您可以通过<a :href="'tel:400-770-8966'">400-770-8966</a>联系我们。
      </p>
    </div>
    <div>
      <h2>四、变更</h2>  
      <p>
        我们会适时对本声明进行修订，该等修订构成本声明的一部分。公司（即【北京顶之美建筑科技有限责任公司】）会将修改后的声明予以发布。在该种情况下，若您继续使用我们的服务，即表示同意接受经修订的声明的约束。
      </p>
    </div>
    <div class="c_center">
      <!-- <span class=""><img :src="closeImg" class="closeSecretOk" @click="closeSecretOk()"></span> -->
      <div class="closeSecretOk" @click="closeSecretOk()">关闭</div>
    </div>
    </div>
    <!-- <div class="srcretFoot">
      <div class="closeSecret" @click="closeSecret">关闭</div>
    </div> -->
    

    </div>
    
  </div>
</div>
</template>

<script>
import { Toast, Indicator, Popup, Picker } from "mint-ui";
import { Checkbox, CheckboxGroup } from 'vant';
//引入 省市区
let addressList = require("../comm/addressListNew.js");
export default {
  name: "custInfoSource",
  data: function() {
    return {
      bgimg: require("../assets/images/custinfobg.png"),
      selectImg: require("../assets/images/combobox.png"),
      custInfoOkImg: require("../assets/images/custinfookbg.png"),
      closeImg: require("../assets/images/close.png"),
      isread: true,
      isSendok: false,
      custInfo: {
        username: "",
        phone: "",
        province: "",
        provinceid: "",
        city: "",
        cityid: "",
        district: "",
        districtid: "",
        address: "",
        part: "",
        sex: 0,
        shareid: "",
        area: 0,
        wxtype: "",
        wxtypeid: "",
        wxpart: "",
        wxpartid: "",
        ctservice:1
      },
      //所在区域的省市区
      addr: {
        chooseType: "province",
        province: "",
        city: "",
        district: "",
        //热门城市
        hotList: [
          {
            name: "北京",
            type: "district",
            province: "北京市",
            provinceid: "110000",
            city: "北京市",
            cityid: "110100",
            district: "",
            districtid: ""
          },
          {
            name: "天津",
            type: "district",
            province: "天津市",
            provinceid: "120000",
            city: "天津市",
            cityid: "120100",
            district: "",
            districtid: ""
          },
          {
            name: "四川",
            type: "city",
            province: "四川省",
            provinceid: "510000",
            city: "",
            cityid: "",
            district: "",
            districtid: ""
          },
          {
            name: "陕西",
            type: "city",
            province: "陕西省",
            provinceid: "610000",
            city: "",
            cityid: "",
            district: "",
            districtid: ""
          },
          {
            name: "武汉",
            type: "district",
            province: "湖北省",
            provinceid: "420000",
            city: "武汉市",
            cityid: "420100",
            district: "",
            districtid: ""
          },
          {
            name: "上海",
            type: "district",
            province: "上海市",
            provinceid: "310000",
            city: "上海市",
            cityid: "310100",
            district: "",
            districtid: ""
          },
          {
            name: "杭州",
            type: "district",
            province: "浙江省",
            provinceid: "330000",
            city: "杭州市",
            cityid: "330100",
            district: "",
            districtid: ""
          },
          {
            name: "广州",
            type: "district",
            province: "广东省",
            provinceid: "440000",
            city: "广州市",
            cityid: "440100",
            district: "",
            districtid: ""
          }
        ],
        chooseList: [],
        provinceList: [],
        cityList: [],
        districtList: [],
        // showtoolbar:true,
        isShow: false
      },
      //渗漏部位
      partone: "",
      parttwo: "",
      partParam: {
        chooseType: "partone",
        partone: "",
        partoneid: "",
        parttwo: "",
        parttwoid: "",
        chooseList: [],
        partoneList: [],
        parttwoList: [],
        isShow: false
      },
      addresshelp: "",
      isLookSecret: false
    };
  },
  computed: {},
  created: function() {
    var that = this;
    let shareid = this.$route.query.shareid;
    let ctservice = this.$route.query.ctservice;
    if (shareid) {
      that.custInfo.shareid = shareid;
    }
    if(ctservice){
      debugger
      that.custInfo.ctservice = ctservice;  
    }
    that.init();
  },
  mounted: function() {
    // console.log(222)
    // debugger
    this.getPartList();
  },
  methods: {
    // 选择省市区
    init() {
      this.getProvinceList();
      // this.getdepthList();
    },
    addrClick: function() {
      this.addr.isShow = true;
    },
    chooseAddress: function(type) {
      debugger;
      if (type == "province") {
        this.addr.chooseList = this.addr.provinceList;
        this.addr.province = "";
        this.addr.city = "";
        this.addr.district = "";
        this.addr.cityList = [];
        this.addr.districtList = [];
      } else if (type == "city" && this.addr.province) {
        var provinceList = this.addr.provinceList;
        var cityList = [];
        for (let i = 0, j = provinceList.length; i < j; i++) {
          if (provinceList[i].name == this.addr.province) {
            cityList = provinceList[i].child;
            break;
          }
        }
        this.addr.cityList = cityList;
        this.addr.city = "";
        this.addr.district = "";
        this.addr.districtList = [];
        this.addr.chooseList = cityList;
      } else if (type == "district" && this.addr.province && this.addr.city) {
        var cityList = this.addr.cityList || [];
        if (cityList.length < 1) {
          var provinceList = this.addr.provinceList;
          for (let i = 0, j = provinceList.length; i < j; i++) {
            if (provinceList[i].name == this.addr.province) {
              cityList = provinceList[i].child;
              break;
            }
          }
        }
        var districtList = [];
        for (let ii = 0, jj = cityList.length; ii < jj; ii++) {
          if (cityList[ii].name == this.addr.city) {
            districtList = cityList[ii].child;
            break;
          }
        }
        if (!this.addr.district) {
          this.addr.district = "";
        }
        this.addr.districtList = districtList;
        this.addr.chooseList = districtList;
      }
      this.addr.chooseType = type;
    },
    getProvinceList: function() {
      let addr = addressList.default.addressDataNew;
      this.addr.province = this.province || "";
      this.addr.city = this.city || "";
      this.addr.district = this.district || "";
      this.addr.provinceList = addr;
      if (this.province) {
        this.chooseAddress("district");
      } else {
        this.chooseAddress("province");
      }
    },
    chooseClick: function(item) {
      debugger;
      var chooseType = this.addr.chooseType;
      if (chooseType == "province") {
        this.addr.province = item.name;
        this.addr.provinceid = item.id;
        this.addr.cityList = item.child;
        this.addr.chooseList = item.child;
        this.addr.chooseType = "city";
      } else if (chooseType == "city") {
        this.addr.city = item.name;
        this.addr.cityid = item.id;
        this.addr.districtList = item.child;
        this.addr.chooseList = item.child;
        this.addr.chooseType = "district";
      } else if (chooseType == "district") {
        this.addr.district = item.name;
        this.addr.districtid = item.id;
        this.saveAddrClick();
      }
    },
    saveAddrClick: function(bool) {
      if (!bool) {
        this.custInfo.province = this.addr.province;
        this.custInfo.provinceid = this.addr.provinceid;
        this.custInfo.city = this.addr.city;
        this.custInfo.cityid = this.addr.cityid;
        this.custInfo.district = this.addr.district;
        this.custInfo.districtid = this.addr.districtid;
      }
      this.addresshelp =
        this.custInfo.province == this.custInfo.city
          ? this.custInfo.province + this.custInfo.district
          : this.custInfo.province +
              this.custInfo.city +
              this.custInfo.district || "";
      this.addr.isShow = false;
    },
    hotClick: function(item) {
      debugger;
      this.addr.province = item.province;
      this.addr.provinceid = item.provinceid;
      this.addr.city = item.city;
      this.addr.cityid = item.cityid;
      this.addr.district = item.district;
      this.addr.districtid = item.districtid;
      this.addr.cityList = [];
      this.addr.districtList = [];
      this.addr.chooseType = item.type;
      this.chooseAddress(item.type);
    },
    partClick: function() {
      this.partParam.isShow = true;
    },
    // 渗漏部位
    getPartList() {
      // debugger
      let that = this;
      this.$ajax.get(
        this.$$api.mobile.getCodeList,
        {
          codetype: "REPAIR_PARTS"
        },
        function(res) {
          let list = res.data.detailMsg.data || [];
          let partoneList_temp = list.filter(item => !item.parentid);
          let parttwoList = list.filter(item => item.parentid);
          let partoneList = partoneList_temp.map(item => {
            let arr = parttwoList.filter(
              subitem => item.codevalue == subitem.parentid
            );
            item.child = arr || [];
            return item;
          });
          that.partParam.partoneList = partoneList || [];
          that.choosePart("partone");
        }
      );
    },
    savePartClick: function(bool) {
      debugger;
      if (!bool) {
        this.custInfo.part =
          (this.partParam.partone || "") + "-" + (this.partParam.parttwo || "");
        this.custInfo.wxtype = this.partParam.partone;
        this.custInfo.wxtypeid = this.partParam.partoneid;
        this.custInfo.wxpart = this.partParam.parttwo;
        this.custInfo.wxpartid = this.partParam.parttwoid;
        this.partone = this.partParam.partone;
        this.partoneValue = this.partParam.partoneValue;
        this.parttwo = this.partParam.parttwo;
        this.parttwoValue = this.partParam.parttwoValue;
      }
      this.partParam.isShow = false;
    },
    choosePart: function(type) {
      debugger;
      if (type == "partone") {
        this.partParam.chooseList = this.partParam.partoneList;
        this.partParam.partone = "";
        this.partParam.partoneid = "";
        this.partParam.parttwo = "";
        this.partParam.parttwoid = "";
        this.partParam.parttwoList = [];
      } else if (type == "parttwo" && this.partParam.partone) {
        var partoneList = this.partParam.partoneList;
        var parttwoList = [];
        for (let i = 0, j = partoneList.length; i < j; i++) {
          if (partoneList[i].name == this.partParam.province) {
            parttwoList = partoneList[i].child;
            break;
          }
        }
        this.partParam.parttwoList = parttwoList;
        this.partParam.chooseList = parttwoList;
      }
      this.partParam.chooseType = type;
    },
    partChooseClick: function(item) {
      var chooseType = this.partParam.chooseType;
      if (chooseType == "partone") {
        this.partParam.partone = item.codetext;
        this.partParam.partoneid = item.codevalue;
        this.partParam.partoneValue = item.codevalue;
        this.partParam.parttwoList = item.child;
        this.partParam.chooseList = item.child;
        this.partParam.chooseType = "parttwo";
      } else if (chooseType == "parttwo") {
        this.partParam.parttwo = item.codetext;
        this.partParam.parttwoid = item.codevalue;
        this.partParam.parttwoValue = item.codevalue;
        this.savePartClick();
      }
    },
    partClick: function() {
      this.partParam.isShow = true;
    },
    // 提交留资信息
    toSaveCustInfo: function() {
      var that = this;
      console.log(this.isread);
      if (!this.isread) {
        Toast({
          message: "请您查看勾选:我已阅读并且同意《保密协议》",
          duration: 1500
        });
        return;
      }
      debugger;
      if (!that.checkisempty(that.custInfo.username)) {
        Toast({ message: "请您填写姓名", duration: 1500 });
        return;
      }
      if (!that.checkisempty(that.custInfo.phone)) {
        Toast({ message: "请您填写手机号码", duration: 1500 });
        return;
      }
      var moboliec = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (!moboliec.test(that.custInfo.phone)) {
        Toast({ message: "请您填写正确的手机号码", duration: 1500 });
        return;
      }
      if (
        !that.checkisempty(that.custInfo.province) ||
        !that.checkisempty(that.custInfo.city) ||
        !that.checkisempty(that.custInfo.district)
      ) {
        Toast({ message: "请您填写完整区域", duration: 1500 });
        return;
      }
      if (
        !that.checkisempty(that.custInfo.wxtypeid) ||
        !that.checkisempty(that.custInfo.wxpartid)
      ) {
        Toast({ message: "请您填写完整部位", duration: 1500 });
        return;
      }
      that.$ajax.post(
        that.$$api.mobile.saveBillDeal,
        that.custInfo,
        response => {
          debugger;
          console.log(response);
          if (response.status >= 200 && response.status < 300) {
            var resdata = response.data;
            if (resdata) {
              var statusStr = resdata.status;
              if (statusStr == 200 || statusStr == 202) {
                that.isSendok = true;
              } else {
                Toast({
                  message: resdata.message,
                  duration: 1500
                });
              }
            }
          } else {
            Toast({
              message: "上传留资信息失败，请联系管理员",
              duration: 1500
            });
          }
        }
      );
    },
    readAgreement: function() {
      console.log(6666);
      // 显示弹窗
      this.isLookSecret = true;
    },
    closeInfoOk: function() {
      console.log(8888);
      this.isSendok = false;
    },
    checkisempty: function(attr) {
      if (attr == null || attr == "" || attr == undefined) {
        return false;
      }
      return true;
    },
    closeSecretOk:function(){
      console.log('7788');
      this.isLookSecret = false;
    }
  }
};
</script>

<style scoped>
/* pages/personalinfo/personalinfo.wxss */
.containerwrap {
  width: 100%;
  background-color: #ffffff;
  min-height: 100vh;
  margin-top: -9vh;
}
#bgImg {
  width: 100%;
  background-size: 100% 100%;
}
.group {
  width: 100%;
  margin: auto;
  /*height: 1rem;*/
  height: 10vw;
  overflow: hidden;
  /* margin-bottom: 8vw; */
  /* margin-bottom: 6vw; */
  padding-bottom: 0.5vh;
  border-bottom: 0.7px solid #ccc;
}
/* .group:first-child{
    border-bottom: .7px solid #ccc;
  } */
.group:last-child {
  overflow: initial;
}
.fieldname {
  font-size: 4vw;
  width: 16vw;
  font-weight: bold;
}
.content input {
  width: 100%;
  height: 100%;
  outline: 0;
  border: 0;
  padding: 0;
  font-size: 4vw;
}
.custInfoContainer {
  width: 80%;
  margin: -30px auto 0;
}
/*.model_addr*/
.model_addr {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 22;
  width: 100vw;
  height: 100vh;
  font-size: 4vw;
}
.model-bg {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 25;
}

.model_addr .model-body {
  position: absolute;
  bottom: 0;
  left: 0;
  z-index: 30;
  width: 100%;
  height: 65vh;
  background: #fff;
}
.model_addr .model-header {
  height: 6vh;
  padding: 0 5vw;
  border-bottom: 0.5px solid #ccc;
  font-size: 5vw;
}
.model_addr .model-hot-title {
  color: #878787;
  padding: 3vw;
}
.model_addr .model-hot-list {
  padding: 0 5vw;
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  font-size: 4vw;
  flex-wrap: wrap;
}
.model_addr .model-hot-group.bg_red {
  color: #fff;
  background: #dc1f31;
}
.model_addr .model-hot-group {
  padding: 2vw 5vw;
  background: #f2f2f2;
  border-radius: 5vw;
  margin-bottom: 2vw;
  margin-right: 3vw;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex-wrap: wrap;
}
.model_addr .model-choose-title {
  border-bottom: 0.5px solid #f2f2f2;
  box-sizing: border-box;
  width: 100%;
  padding: 0 5vw;
  font-size: 4vw;
}
.model_addr .model-choose-title div.c_red {
  border-bottom: 1px solid #dc1f31;
  margin-bottom: 1px;
}
.model_addr .model-choose-title div {
  height: 8vw;
  max-width: 30vw;
  margin-right: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.model_addr .model-body,
.model_addr .model-choose {
  display: flex;
  flex-direction: column;
}
.model_addr .model-choose {
  flex: 1;
  overflow: auto;
}
.model_addr .model-choose-list {
  width: 100%;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
  /*height: calc( 100% - 30vh);*/
  /*height: 38vh;*/
  flex: 1;
  overflow-x: hidden;
  overflow-y: auto;
}
.model_addr .model-choose-group {
  padding: 3vw 5vw;
  text-align: left;
}
.item-value {
  font-size: 4vw;
}
.selectImg {
  width: 5vw;
}
.widthauto {
  width: auto !important;
}
#footerWrap {
  width: 80%;
  margin: 5vw auto 0;
  padding-bottom: 5vw;
}
.toSaveInfoBtn {
  background-color: #d42c25;
  color: #ffffff;
  padding: 0.3rem;
  border-radius: 5px;
  margin: auto;
  font-size: 6vw;
  text-align: center;
  font-weight: bold;
}
.agreement {
  color: #43affd;
  font-size: 4vw;
}
.opacity03 {
  opacity: 0.3;
}
.custinfoOKWrap {
  width: 80vw;
  position: fixed;
  top: 30vh;
  left: 10vw;
  background: #ffffff;
  border-radius: 5vw;
}
.isLookSecretWrap {
  width: 96vw;
    height: 90vh;
    position: absolute;
    top: 5vh;
    left: 2vw;
    background: #ffffff;
    overflow-y: scroll;
    z-index: 999;
    border-radius: 5vw;
}
.custInfoOkImg {
  width: 100%;
  height: 100%;
}
.closeInfoOk {
  position: absolute;
  right: 2vw;
  top: 2vw;
  font-size: 6vw;
  color: #ffffff;
  width: 8vw;
  height: 8vw;
}
.text1 {
  text-align: center;
  font-size: 6vw;
  color: #e60011;
  font-weight: 500;
  margin: 2vw auto;
}
.text2 {
  text-align: center;
  font-size: 4vw;
  margin: 3vw auto 8vw;
}
.model-cancel {
  font-size: 10vw;
}
.inputpart {
  background-color: #ffffff !important;
}
.secretContentWrap {
  width: 96%;
  margin: auto;
}
.secretContentWrap p {
  font-size: 4vw;
}
.in-block {
  display: block;
}
.closeSecretOk{
  width: 25%;
  background-color: #43affd;
  color: #ffffff;
  padding: 0.2rem 0.3rem;
  border-radius: 5px;
  color: #fff;
  margin: auto;
  font-size: 5vw;
  text-align: center;
}
/* .secretHead{
  position: fixed;
    top: 6vh;
    height: 40px;
    line-height: 40px;
} */
</style>



// WEBPACK FOOTER //
// src/components/custInfoSource.vue